import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_AUDIT_REVISIONS: createSagaAction('GET_AUDIT_REVISIONS')
}

// Action Creators
export const actions = {
  getAuditRevisions: ({ targetId, table }) => ({
    type: constants.GET_AUDIT_REVISIONS.ACTION,
    targetId,
    table
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_AUDIT_REVISIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_AUDIT_REVISIONS.SUCCESS:
      return {
        ...state,
        revisions: action.payload,
        loading: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/auditActions.js